// cod-form build marker: 2026-10-17-rc2 (two-button Buy Now/Add to Cart +
// border/outline + transparent-background button options; forces a fresh
// asset fingerprint on push, ruling out stale CDN/browser caching of an
// older build as an explanation for a fix not appearing live).
(function () {
  // Guards against this whole script running twice on one page load. This
  // can happen in practice — e.g. a merchant has BOTH the standalone "COD
  // Order Form" section AND this same #cod-form-root block pasted directly
  // into their own product template — and since `document.getElementById`
  // always returns the FIRST element for a duplicate id, every extra
  // <script> tag would otherwise re-initialize against that SAME first
  // element: duplicate buttons, duplicate click handlers, duplicate modal
  // overlays appended to <body>, and (depending on what killWrapperChrome
  // below touches on ancestor elements) layout bugs like the page losing
  // its horizontal centering. This flag makes every execution after the
  // first a harmless no-op instead, regardless of which section caused the
  // duplicate script tag.
  if (window.__codFormBooted) return;
  window.__codFormBooted = true;

  const root = document.getElementById('cod-form-root');
  if (!root) return;

  const SHOP = root.dataset.shop;
  const WORKER_URL = root.dataset.workerUrl;
  const PAGE_TYPE_BASE = root.dataset.pageType || 'product';
  // Can be flipped to 'cart' temporarily when the order is started from the
  // slide-out cart drawer (window.CODOrderCart), then flips back.
  let PAGE_TYPE = PAGE_TYPE_BASE;
  // Root placed only inside the cart drawer on pages with no product/cart root:
  // no inline button, just powers the drawer's COD button.
  const DRAWER_ONLY = root.dataset.drawerOnly === 'true';
  // Set only by the theme app embed (extensions/cod-order-form), which
  // injects its own #cod-form-root at the very end of <body> on EVERY page
  // automatically (Theme Customizer -> App embeds toggle, no code to paste
  // per store/page). Shopify app embeds can only append there, not inline
  // next to a specific section's Buy Box — so this mode skips the inline
  // button entirely and shows ONLY the always-visible floating sticky bar,
  // which doesn't need a specific DOM position to work. A theme that also
  // has the manual inline snippet pasted in still wins: that root sits
  // earlier in the DOM and document.getElementById('cod-form-root') above
  // already resolved to it, so this embed's own root is simply never
  // reached — no double-rendering to guard against here.
  const STICKY_ONLY = root.dataset.stickyOnly === 'true';
  const PRODUCT_ID = root.dataset.productId;
  const PRODUCT_TITLE = root.dataset.productTitle || '';
  // These start from the page's default variant (Liquid-rendered at load
  // time) but are re-assigned live whenever the theme's own size/variant
  // picker fires a `cod:variant-change` event — see the listener near the
  // bottom of this file.
  let VARIANT_ID = root.dataset.variantId;
  let VARIANT_TITLE = root.dataset.variantTitle || '';
  let PRODUCT_IMAGE = root.dataset.productImage || '';
  let UNIT_PRICE = Number(root.dataset.unitPrice || 0);
  function getDisplayTitle() {
    return (VARIANT_TITLE && VARIANT_TITLE !== 'Default Title')
      ? PRODUCT_TITLE + ' - ' + VARIANT_TITLE
      : PRODUCT_TITLE;
  }
  const CURRENCY = root.dataset.currency || 'Rs.';
  // Display symbol (e.g. "Rs.") for UI formatting only — NOT valid for ad
  // pixels, which require an ISO 4217 currency code (e.g. "PKR"). Keep this
  // separate constant for anything sent to Facebook/TikTok pixels.
  const CURRENCY_CODE = root.dataset.currencyCode || 'PKR';

  const DEFAULT_FIELDS = [
    { id: 'name', label: 'Full Name', placeholder: 'e.g. Ali Raza', type: 'text', required: true },
    { id: 'phone', label: 'Phone Number', placeholder: '03xxxxxxxxx', type: 'text', required: true },
    { id: 'city', label: 'City', placeholder: 'e.g. Faisalabad', type: 'text', required: true },
    { id: 'address', label: 'Full Address', placeholder: 'House #, Street, Area', type: 'text', required: true },
  ];

  let SETTINGS = {};
  let PIXELS = [];
  let FIELDS = DEFAULT_FIELDS;
  let qty = 1;
  let modalEl, overlayEl;
  let codScrollRestoreY = 0;
  let CART_DATA = null; // cart-page mode only — populated from /cart.js

  function fmt(n) { return CURRENCY + ' ' + Math.round(n).toLocaleString(); }
  function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str).replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  }
  function normalizeImageUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  // Dashboard's Heading/Body/Button font pickers only set a CSS
  // font-family string (e.g. "'Poppins', sans-serif") — the actual font
  // file was never being loaded anywhere, so picking anything other than
  // the theme's own font silently did nothing. This loads the picked
  // Google Font family via a stylesheet <link>, once per family per page.
  const _loadedFonts = {};
  function ensureGoogleFont(fontFamilyCss) {
    if (!fontFamilyCss || fontFamilyCss === 'inherit') return;
    const match = fontFamilyCss.match(/'([^']+)'/);
    if (!match) return;
    const family = match[1];
    if (_loadedFonts[family]) return;
    _loadedFonts[family] = true;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    const famParam = encodeURIComponent(family).replace(/%20/g, '+');
    link.href = 'https://fonts.googleapis.com/css2?family=' + famParam + ':wght@400;600;700&display=swap';
    // Fonts with only one weight (Anton, Bebas Neue, ...) make Google reject
    // the multi-weight request, so retry once with the plain family name.
    link.onerror = function () {
      const plain = document.createElement('link');
      plain.rel = 'stylesheet';
      plain.href = 'https://fonts.googleapis.com/css2?family=' + famParam + '&display=swap';
      document.head.appendChild(plain);
    };
    document.head.appendChild(link);
  }

  // GET with automatic retries. Some mobile networks drop the first request to
  // the Worker (QUIC idle timeout / network blips); a second or third try
  // almost always goes through. Only used for read-only requests.
  // The worker is reachable on two hostnames. Some ISPs reset/throttle one of
  // them, so on failure we rotate to the other and remember whichever works.
  const HOSTS = [WORKER_URL, 'https://cod.nitestyles.store', 'https://cod-form-app.bilalstore.workers.dev']
    .filter((h, i, a) => h && a.indexOf(h) === i);
  let hostIdx = 0;
  // Hedged request across hostnames: try the last-known-good host first; if it
  // fails (or is slow, >1.2s) start the next one. First good answer wins. Normal
  // case = a single request and no console errors; a bad host costs only a
  // fast fallback. The winning host is remembered for the next page view.
  function preferredHosts() {
    let pref = '';
    try { pref = localStorage.getItem('cod_host') || ''; } catch (e) { /* ignore */ }
    const list = HOSTS.slice();
    const k = list.indexOf(pref);
    if (k > 0) list.unshift(list.splice(k, 1)[0]);
    return list;
  }
  function hedgedFetch(path, opts) {
    const order = preferredHosts();
    return new Promise((resolve, reject) => {
      let done = false, failed = 0, next = 0, lastErr;
      const timers = [];
      function launch() {
        if (done || next >= order.length) return;
        const host = order[next++];
        timers.push(setTimeout(launch, 1200));
        fetch(host + path, opts).then((res) => {
          if (done) return;
          if (res.ok || res.status < 500) {
            done = true; timers.forEach(clearTimeout);
            try { localStorage.setItem('cod_host', host); } catch (e) { /* ignore */ }
            hostIdx = Math.max(0, HOSTS.indexOf(host));
            resolve(res);
          } else { onFail(new Error('HTTP ' + res.status)); }
        }).catch(onFail);
      }
      function onFail(e) {
        lastErr = e; failed++;
        if (done) return;
        if (next < order.length) launch();
        else if (failed >= order.length) { done = true; timers.forEach(clearTimeout); reject(lastErr); }
      }
      launch();
    });
  }
  async function fetchRetry(path, opts) {
    const delays = [0, 500, 1200, 2500, 4000, 6000, 8000];
    let lastErr;
    for (let i = 0; i < delays.length; i++) {
      if (delays[i]) await new Promise((r) => setTimeout(r, delays[i]));
      try { return await hedgedFetch(path, opts); } catch (e) { lastErr = e; }
    }
    throw lastErr;
  }

  // Order POST: only rotate hosts when the request itself failed to connect
  // (a reset before any response), so an order that reached the server is never re-sent.
  async function postOrderFetch(opts) {
    let lastErr;
    for (let i = 0; i < HOSTS.length; i++) {
      const idx = (hostIdx + i) % HOSTS.length;
      try {
        const res = await fetch(HOSTS[idx] + '/api/orders', opts);
        hostIdx = idx;
        return res;
      } catch (e) {
        lastErr = e;
      }
    }
    throw lastErr;
  }

  async function init() {
    // Tracks whether the settings fetch actually succeeded, separately from
    // SETTINGS itself (which falls back to {} either way) — see the
    // anti-FOUC handling right below, which depends specifically on this.
    let settingsLoadedOk = false;
    try {
      const [settingsRes, pixelsRes] = await Promise.all([
        fetchRetry('/api/settings/public?shop=' + encodeURIComponent(SHOP), { cache: 'no-store' }),
        fetchRetry('/api/pixels/public?shop=' + encodeURIComponent(SHOP), { cache: 'no-store' }),
      ]);
      SETTINGS = settingsRes.ok ? await settingsRes.json() : {};
      const pixelData = pixelsRes.ok ? await pixelsRes.json() : { pixels: [] };
      PIXELS = pixelData.pixels || [];
      settingsLoadedOk = settingsRes.ok;
    } catch (e) {
      console.error('COD form: could not load settings', e);
      SETTINGS = {};
      PIXELS = [];
    }

    // The anti-FOUC stylesheet in theme.liquid's <head> hides the native Add
    // to Cart / Buy Now / Checkout buttons immediately on page load, before
    // this fetch has resolved, so there's no flash of them before the COD
    // button is ready. applyVisibility() below re-applies the real hiding
    // from the fetched settings, so once settings are in, this placeholder
    // can come off.
    //
    // BUG FIXED: this used to remove the placeholder unconditionally, even
    // when the fetch above failed (e.g. a flaky network — this exact
    // ERR_QUIC_PROTOCOL_ERROR/timeout was seen live). On a failed fetch,
    // SETTINGS is {}, so SETTINGS.hide_checkout_cart reads as false and
    // applyVisibility() never re-hides Checkout — meaning a merchant who
    // wants Checkout hidden would see it flash back to fully visible and
    // stay that way for that whole page load, purely because of a transient
    // network hiccup, with no way to tell the difference from "this shop
    // doesn't hide checkout." Only remove the placeholder once we know the
    // real settings loaded; on failure, leave native buttons hidden (safer
    // default — this app's whole point is routing orders through the COD
    // flow, so staying hidden is the safe failure mode, not showing).
    const antiFouc = document.getElementById('cod-anti-fouc');
    if (antiFouc && settingsLoadedOk) antiFouc.remove();

    const showOn = SETTINGS.form_visibility || 'both';
    if (showOn === 'disabled') return;
    if (!DRAWER_ONLY && showOn === 'product' && PAGE_TYPE !== 'product') return;
    if (!DRAWER_ONLY && showOn === 'cart' && PAGE_TYPE !== 'cart') return;

    ensureGoogleFont(SETTINGS.heading_font);
    ensureGoogleFont(SETTINGS.body_font);
    ensureGoogleFont(SETTINGS.button_font);

    try {
      FIELDS = SETTINGS.fields_config ? JSON.parse(SETTINGS.fields_config) : DEFAULT_FIELDS;
      if (!Array.isArray(FIELDS) || FIELDS.length === 0) FIELDS = DEFAULT_FIELDS;
    } catch (e) {
      FIELDS = DEFAULT_FIELDS;
    }

    applyVisibility();
    killWrapperChrome();

    if (DRAWER_ONLY) {
      // nothing inline; modal is built on demand by CODOrderCart
    } else if (PAGE_TYPE === 'cart') {
      await initCartMode();
    } else {
      if (STICKY_ONLY) {
        renderStickyOnlyProductBar();
      } else {
        renderBuyButton();
      }
      buildModal();
    }
    preloadPixelBaseScripts();
    setupDrawerButtons();
  }

  // ---------- Slide-out cart drawer support ----------
  // Put <div class="cod-drawer-btn"></div> in the theme's cart drawer. Every
  // empty one gets a COD button (styled from the Add to Cart Button
  // dashboard settings) that orders everything in the cart. The drawer is
  // re-rendered by the theme on every cart change, so we re-mount on mutation.
  window.CODOrderCart = function () {
    PAGE_TYPE = 'cart';
    const go = async () => {
      try {
        const res = await fetch('/cart.js', { cache: 'no-store' });
        CART_DATA = await res.json();
      } catch (e) { CART_DATA = CART_DATA || { items: [], total_price: 0 }; }
      if (!modalEl) buildModal();
      return openModal();
    };
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') { try { drawer.close(); } catch (e) {} }
    return go();
  };

  function mountDrawerButtons() {
    document.querySelectorAll('.cod-drawer-btn:empty').forEach((el) => {
      const hs = hardShadow('atc');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.innerHTML = btnHtml('atc', 'Order Now');
      btn.style.cssText = btnStyleCss('atc', '#111111', '#ffffff') +
        ' width:' + (hs ? 'calc(100% - ' + hs.x + 'px)' : '100%') + ' !important; margin:0 ' + (hs ? hs.x : 0) + 'px ' + (hs ? hs.y : 0) + 'px 0 !important; display:block;';
      btn.addEventListener('click', () => window.CODOrderCart());
      el.appendChild(btn);
      applyBtnAnimation(btn, SETTINGS.atc_btn_animation, SETTINGS.atc_btn_bg || '#111111');
    });
  }

  function setupDrawerButtons() {
    mountDrawerButtons();
    let t = null;
    new MutationObserver(() => {
      if (t) return;
      t = setTimeout(() => { t = null; mountDrawerButtons(); }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ---------- Cart-page mode: one COD order for every item currently in cart ----------
  async function initCartMode() {
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      CART_DATA = await res.json();
    } catch (e) {
      CART_DATA = { items: [], total_price: 0 };
    }
    if (!CART_DATA.items || CART_DATA.items.length === 0) return; // empty cart — nothing to show
    if (!STICKY_ONLY) renderBuyButton();
    buildModal();
    // Sticky bar on phones only (same as the product page); on desktop the
    // normal inline button is enough.
    if (SETTINGS.atc_btn_sticky !== false && window.matchMedia('(max-width: 768px)').matches) renderPersistentCartBar();
  }

  // Something on the cart page hides an ancestor of #cod-form-root a
  // second or two after load, and it turned out our earlier fix for that
  // (forcing ancestor styles back via a MutationObserver) was interfering
  // with Shopify's own cart-update AJAX cycle and causing "There was an
  // error while updating your cart". So instead of fighting that ancestor
  // at all, this renders a second, always-visible Buy button as a fixed
  // bar pinned to the bottom of the screen, appended directly to
  // document.body — completely outside whatever container was getting
  // hidden, and it never touches or observes anything else on the page, so
  // it can't collide with the cart's own update mechanism.
  function renderPersistentCartBar() {
    if (document.getElementById('cod-cart-persistent-bar')) return;

    // This sticky bar only ever shows on the cart page, so it's styled from
    // the Add to Cart Button settings (prefix 'atc'), independent from the
    // product-page Buy Now button.
    const bar = document.createElement('div');
    bar.id = 'cod-cart-persistent-bar';
    // Background is forced transparent here, deliberately NOT
    // btnWrapperBgColor('atc') — that setting is for the backdrop directly
    // behind the INLINE button (e.g. to patch corner-clipping against a
    // colored page background), and was never meant to paint a solid bar
    // behind the floating sticky copy. A merchant who set a dark wrapper
    // color for the inline button was unexpectedly getting a dark bar
    // across the whole bottom of the screen on this one too.
    bar.style.cssText = `
      position: fixed; left: 0; right: 0; bottom: 0; z-index: 2147483000;
      background: transparent;
      padding: 0 0 env(safe-area-inset-bottom);
    `;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.innerHTML = btnHtml('atc', 'Add to Cart');
    // Full, uniform corner rounding on every side — matching exactly what
    // the merchant set as the button's own radius, same as the inline
    // button looks. This used to force only the top two corners round
    // (border-radius:0 + border-top-*-radius) for a flush "bottom sheet"
    // look, but a rounded setting should look rounded everywhere it's
    // used, not flat on the bottom edge — so this now just lets the
    // normal btnStyleCss radius (uniform on all 4 corners) apply as-is.
    // width:calc(100% - 4px) + margin:0 2px gives it a small left/right
    // inset so it reads as a floating rounded button, not a flush bar —
    // width:100% is kept as the explicit base (not left to btnStyleCss,
    // which omits it for the 'atc' prefix so the desktop width/align
    // feature can own the INLINE button's width) since a <button> doesn't
    // reliably stretch to fill its container from display:block alone.
    btn.style.cssText = btnStyleCss('atc', '#111111', '#ffffff') + ` width:calc(100% - 4px) !important; margin:0 2px !important;`;
    btn.addEventListener('click', openModal);
    bar.appendChild(btn);
    document.body.appendChild(bar);
    applyBtnAnimation(btn, SETTINGS.atc_btn_animation, SETTINGS.atc_btn_bg || '#111111');
    // Only show this bar while the normal inline button is off screen —
    // otherwise the cart page shows the same button twice. With no inline
    // button to watch (sticky-only mode) the bar just stays visible.
    const inlineBtn = document.getElementById('cod-atc-btn');
    const barH = btn.offsetHeight;
    if (inlineBtn && 'IntersectionObserver' in window) {
      // Hidden = pushed well below the screen AND visibility:hidden, so no
      // sliver of the button's shadow/animation can ever peek in.
      bar.style.transform = 'translateY(calc(100% + 40px))';
      bar.style.visibility = 'hidden';
      bar.style.transition = 'transform .2s ease, visibility 0s linear .2s';
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const show = !entry.isIntersecting;
          if (show) {
            bar.style.transition = 'transform .2s ease, visibility 0s';
            bar.style.visibility = 'visible';
            bar.style.transform = 'translateY(0)';
          } else {
            bar.style.transition = 'transform .2s ease, visibility 0s linear .2s';
            bar.style.transform = 'translateY(calc(100% + 40px))';
            bar.style.visibility = 'hidden';
          }
          document.body.style.setProperty('padding-bottom', show ? barH + 'px' : '0px');
        });
      }, { threshold: 0 }).observe(inlineBtn);
    } else {
      document.body.style.setProperty('padding-bottom', barH + 'px');
    }
  }

  // ---------- Hide native Shopify buttons per Visibility settings ----------
  // ---------- Force-strip any theme wrapper spacing around our section ----------
  // Walks up from #cod-form-root through every ancestor up to (and including) the
  // Shopify section wrapper, zeroing padding/margin. Background is intentionally
  // left alone — the page's true background here is plain white no matter what,
  // so instead of fighting it we just remove every gap that could reveal it.
  // REVERTED the gap-zeroing/negative-margin version of this function: it
  // read getComputedStyle on an ancestor several levels up into the cart
  // page's OWN Shopify-rendered DOM (the .cart_blocks grid container) and
  // set inline styles on ancestors up through the section wrapper. Right
  // after that shipped, "There was an error while updating your cart"
  // started appearing on the quantity stepper — the exact same error this
  // codebase already hit once before from touching/observing ancestors of
  // #cod-form-root, which collides with Shopify's own cart-update AJAX
  // cycle (see the comment on renderPersistentCartBar above). Rather than
  // risk that again for a cosmetic gap fix, this is back to only ever
  // touching #cod-form-root's own ancestor chain up to (and including) the
  // Shopify section wrapper, and only padding/margin — nothing from the
  // cart's own grid layout.
  function killWrapperChrome() {
    // Opt-out for a #cod-form-root embedded directly inside a merchant's own
    // custom template (set via data-skip-wrapper-fix="true" on the div) —
    // this whole function exists only to erase a theme's OWN unwanted
    // section-wrapper padding/background gap around a STANDALONE COD
    // section (StreetX's setup). When the button is embedded straight into
    // a custom-built template instead, its surrounding containers are the
    // merchant's own deliberate layout (gutters, centering), not stray
    // theme chrome — walking up and zeroing padding/margin there doesn't
    // remove a gap, it strips real layout (seen on Jersee: killed the
    // page's side padding entirely). Skipping it here means this code has
    // zero effect on the page outside the button itself, as it should.
    if (root.dataset.skipWrapperFix === 'true') return;
    let el = root;
    let hops = 0;
    while (el && hops < 8) {
      // Padding is always safe to zero here — on every theme seen so far it
      // only ever added an unwanted gap around the button, never did
      // anything load-bearing.
      el.style.setProperty('padding', '0', 'important');
      // Margin is NOT always safe to force to 0. A custom product template
      // (seen on Jersee's own hand-built "Jersee product" section) can use
      // a container with `margin-inline:auto` to horizontally CENTER itself
      // inside the page — equal, non-zero left/right margins is exactly
      // that centering math. Forcing it to 0 doesn't remove a gap, it
      // deletes the centering and shifts the WHOLE page to one side. Only
      // zero the margin when left/right aren't a matching non-zero pair
      // (i.e. not plausibly a deliberate centering margin).
      const cs = getComputedStyle(el);
      const mLeft = parseFloat(cs.marginLeft) || 0;
      const mRight = parseFloat(cs.marginRight) || 0;
      if (mLeft === 0 || mLeft !== mRight) {
        el.style.setProperty('margin', '0', 'important');
      }
      const isSectionWrapper = el.id && el.id.indexOf('shopify-section') === 0;
      el = el.parentElement;
      hops++;
      if (isSectionWrapper) break;
    }
  }

  function applyVisibility() {
    if (!SETTINGS.hide_add_to_cart && !SETTINGS.hide_buy_now && !SETTINGS.hide_checkout_cart) return;
    const style = document.createElement('style');
    let css = '';
    if (SETTINGS.hide_checkout_cart) {
      css += `
        button[name="checkout"],
        .cart__checkout-button,
        #checkout { display: none !important; }
      `;
    }
    if (SETTINGS.hide_add_to_cart) {
      css += `
        form[action*="/cart/add"] button[name="add"],
        button[name="add"],
        .product-form__submit,
        .product-form__buttons button[type="submit"] { display: none !important; }
      `;
    }
    if (SETTINGS.hide_buy_now) {
      css += `
        shopify-payment-button,
        .shopify-payment-button,
        .shopify-payment-button__button,
        ._rsi-buy-now-button-app-block-hook,
        [class*="buy-now-button-app-block-hook"] { display: none !important; }
      `;
    }
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ---------- Buy Now / Add to Cart buttons ----------
  // Two fully independent buttons — separate text, icon, colors, radius,
  // shadow, animation, transparent/outline style and border, each read
  // from its own `prefix` ("buy" for Buy Now, "atc" for Add to Cart).
  // Both still trigger the exact same COD flow (openModal) — only their
  // look and label are independent.
  // Icon in front of a button's text. With the "Animate icon" option on, the
  // icon flaps (like the butterflies in the header).
  function iconHtml(prefix) {
    const ic = SETTINGS[prefix + '_btn_icon'];
    if (!ic) return '';
    let st;
    try { st = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { st = {}; }
    if (st && st[prefix + '_icon_anim']) {
      if (!document.getElementById('cod-ico-style')) {
        const el = document.createElement('style');
        el.id = 'cod-ico-style';
        el.textContent = '@keyframes codIcoFlap { 0%,100% { transform:scaleX(1); } 50% { transform:scaleX(.6); } } @media (prefers-reduced-motion:reduce){ .cod-ico-flap { animation-duration:3s !important; } }';
        document.head.appendChild(el);
      }
      return '<span class="cod-ico-flap" style="display:inline-block; animation:codIcoFlap 1.2s ease-in-out infinite;">' + escapeHtml(ic) + '</span> ';
    }
    return escapeHtml(ic) + ' ';
  }
  function btnHtml(prefix, fallbackText) {
    return iconHtml(prefix) + escapeHtml(SETTINGS[prefix + '_btn_text'] || fallbackText);
  }

  // The backdrop color sitting directly behind a button, set independently
  // from the button's own fill color — meant to match the real theme/page
  // background (e.g. a merchant enters their page's actual white/cream/etc.
  // color here), NOT the button's own background. Defaults to fully
  // transparent when unset, so a real backdrop only shows up once a
  // merchant deliberately sets one.
  function btnWrapperBgColor(prefix) {
    return SETTINGS[prefix + '_btn_wrapper_bg'] || 'transparent';
  }

  // One-time stylesheet for the Add to Cart button's desktop-only sizing.
  // This has to live in an actual @media rule, not inline styles set from
  // JS at render time — inline styles don't un-apply themselves when the
  // viewport later crosses the breakpoint (e.g. the user resizes, or opens
  // dev tools in responsive mode), and setting them conditionally on
  // window.innerWidth at render time would also miss that. A real
  // `@media (min-width: 769px)` rule, fed by CSS custom properties set on
  // the wrap element, is the only way this both (a) never applies on mobile
  // and (b) responds correctly if the viewport changes after render.
  function injectAtcLayoutStyles() {
    if (document.getElementById('cod-atc-layout-styles')) return;
    const style = document.createElement('style');
    style.id = 'cod-atc-layout-styles';
    style.textContent = `
      /* Mobile-first base rule — applies below 769px, driven by the
         mobile_* settings (independent from the desktop ones below). */
      #cod-atc-wrap {
        display:flex !important;
        justify-content:var(--cod-atc-mobile-justify, center) !important;
        box-sizing:border-box !important;
        padding-top:var(--cod-atc-mobile-mt, 0px) !important;
        padding-bottom:var(--cod-atc-mobile-mb, 0px) !important;
        padding-left:var(--cod-atc-mobile-ml, 0px) !important;
        padding-right:var(--cod-atc-mobile-mr, 0px) !important;
      }
      #cod-atc-wrap #cod-atc-btn { width:var(--cod-atc-mobile-width, 100%) !important; flex:none !important; }
      @media (min-width: 769px) {
        #cod-atc-wrap {
          justify-content:var(--cod-atc-justify, center) !important;
          padding-top:var(--cod-atc-mt, 0px) !important;
          padding-bottom:var(--cod-atc-mb, 0px) !important;
          padding-left:var(--cod-atc-ml, 0px) !important;
          padding-right:var(--cod-atc-mr, 0px) !important;
        }
        #cod-atc-wrap #cod-atc-btn { width:var(--cod-atc-width, 100%) !important; }
      }
    `;
    document.head.appendChild(style);
  }

  // Wraps a button element in its own backdrop <div> (background set to
  // btnWrapperBgColor), sized to exactly fit the button.
  //
  // Only the Add to Cart button (prefix 'atc', the one rendered inline on
  // the cart page) supports narrower width + left/center/right alignment +
  // margin — deliberately not the Buy Now button, and not the separate
  // always-full-width sticky bottom bar (that one doesn't go through this
  // function at all). Desktop (>=769px) and mobile (<769px) have fully
  // independent settings, applied via the two rule sets in
  // injectAtcLayoutStyles above.
  function wrapWithBackdrop(btn, prefix) {
    const isAtc = prefix === 'atc';
    const wrap = document.createElement('div');
    wrap.style.background = btnWrapperBgColor(prefix);

    if (isAtc) {
      injectAtcLayoutStyles();
      wrap.id = 'cod-atc-wrap';

      const align = SETTINGS.atc_btn_align || 'center';
      const justify = align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center';
      const widthPct = Math.min(100, Math.max(10, Number(SETTINGS.atc_btn_width ?? 100)));
      wrap.style.setProperty('--cod-atc-justify', justify);
      wrap.style.setProperty('--cod-atc-width', widthPct + '%');
      wrap.style.setProperty('--cod-atc-mt', Number(SETTINGS.atc_btn_margin_top || 0) + 'px');
      wrap.style.setProperty('--cod-atc-mb', Number(SETTINGS.atc_btn_margin_bottom || 0) + 'px');
      wrap.style.setProperty('--cod-atc-ml', Number(SETTINGS.atc_btn_margin_left || 0) + 'px');
      wrap.style.setProperty('--cod-atc-mr', Number(SETTINGS.atc_btn_margin_right || 0) + 'px');

      const mobileAlign = SETTINGS.atc_btn_mobile_align || 'center';
      const mobileJustify = mobileAlign === 'left' ? 'flex-start' : mobileAlign === 'right' ? 'flex-end' : 'center';
      const mobileWidthPct = Math.min(100, Math.max(10, Number(SETTINGS.atc_btn_mobile_width ?? 100)));
      wrap.style.setProperty('--cod-atc-mobile-justify', mobileJustify);
      wrap.style.setProperty('--cod-atc-mobile-width', mobileWidthPct + '%');
      wrap.style.setProperty('--cod-atc-mobile-mt', Number(SETTINGS.atc_btn_mobile_margin_top || 0) + 'px');
      wrap.style.setProperty('--cod-atc-mobile-mb', Number(SETTINGS.atc_btn_mobile_margin_bottom || 0) + 'px');
      wrap.style.setProperty('--cod-atc-mobile-ml', Number(SETTINGS.atc_btn_mobile_margin_left || 0) + 'px');
      wrap.style.setProperty('--cod-atc-mobile-mr', Number(SETTINGS.atc_btn_mobile_margin_right || 0) + 'px');
    } else {
      wrap.style.display = 'block';
      wrap.style.width = '100%';
    }

    wrap.appendChild(btn);
    return wrap;
  }

  // "Side border" (solid offset shadow, bottom & right) chosen in the Dashboard
  // (Form Design > Button Settings). Returns null when it's switched off.
  function hardShadow(prefix) {
    let st;
    try { st = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { st = {}; }
    if (!st || !st[prefix + '_hs_on']) return null;
    const x = Math.max(0, Number(st[prefix + '_hs_x'] || 0));
    const y = Math.max(0, Number(st[prefix + '_hs_y'] || 0));
    if (!x && !y) return null;
    return { x: x, y: y, css: x + 'px ' + y + 'px 0 ' + (st[prefix + '_hs_color'] || '#1f1a45') };
  }

  // Button text style chosen in the Dashboard (size, bold, capitals, letter spacing).
  function btnPadY(prefix) {
    let st;
    try { st = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { st = {}; }
    const n = Number((st || {})[prefix + '_pad_y']);
    return n >= 0 && isFinite(n) && (st || {})[prefix + '_pad_y'] != null ? Math.max(4, Math.min(48, n)) : 16;
  }

  function btnTextStyle(prefix) {
    let st;
    try { st = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { st = {}; }
    st = st || {};
    const size = Number(st[prefix + '_txt_size'] || (prefix === 'submit' ? 14 : 15));
    const ls = Number(st[prefix + '_txt_ls'] || 0);
    // Single-weight display fonts (Anton etc.) get fake-bolded by the browser
    // when weight 700 is requested, which smears the letters together.
    const SINGLE = /(anton|bebas neue|archivo black|staatliches|fjalla one|righteous|pacifico|lobster|abril fatface|satisfy|great vibes|teko)/i;
    const single = SINGLE.test(String(SETTINGS.button_font || ''));
    const bold = !single && st[prefix + '_txt_bold'] !== false;
    const upper = !!st[prefix + '_txt_upper'];
    return 'font-size:' + size + 'px; font-weight:' + (bold ? 700 : 400) + '; letter-spacing:' + ls + 'px; text-transform:' + (upper ? 'uppercase' : 'none') + ';';
  }

  function btnStyleCss(prefix, fallbackBg, fallbackTextColor) {
    const shadow = Number(SETTINGS[prefix + '_btn_shadow'] || 0);
    const radius = SETTINGS[prefix + '_btn_radius'] ?? 8;
    const fontFamily = SETTINGS.button_font && SETTINGS.button_font !== 'inherit' ? SETTINGS.button_font : 'inherit';
    const isTransparent = !!SETTINGS[prefix + '_btn_transparent'];
    const borderWidth = Number(SETTINGS[prefix + '_btn_border_width'] || 0);
    const borderColor = SETTINGS[prefix + '_btn_border_color'] || SETTINGS[prefix + '_btn_bg'] || fallbackBg;
    const background = isTransparent ? 'transparent' : (SETTINGS[prefix + '_btn_bg'] || fallbackBg);
    const border = borderWidth > 0 ? `${borderWidth}px solid ${borderColor}` : 'none';
    // Width is deliberately left OUT of this inline string for the 'atc'
    // button (every other property here is still inline, same as always).
    // An inline !important declaration always beats a stylesheet rule's
    // !important, no matter how specific the selector — so an inline
    // width:100% here would permanently out-rank the
    // #cod-atc-wrap #cod-atc-btn media-query rule in injectAtcLayoutStyles()
    // that's supposed to apply the merchant's chosen desktop width. Leaving
    // it off entirely lets that stylesheet fully own this button's width.
    const widthDecl = prefix === 'atc' ? '' : 'width:100% !important;';
    return `
      display:block !important; ${widthDecl} padding:${btnPadY(prefix)}px 13px !important; cursor:pointer; ${btnTextStyle(prefix)} font-family:${fontFamily}; box-sizing:border-box !important;
      background:${background} !important; background-image:none !important; color:${SETTINGS[prefix + '_btn_text_color'] || fallbackTextColor};
      border:${border} !important;
      border-radius:${radius}px !important;
      box-shadow:${hardShadow(prefix) ? hardShadow(prefix).css : (shadow > 0 ? '0 ' + shadow + 'px ' + (shadow * 3) + 'px rgba(0,0,0,0.18)' : 'none')};
      -webkit-appearance:none !important; -moz-appearance:none !important; appearance:none !important; outline:none;
      background-clip:padding-box !important; -webkit-background-clip:padding-box !important;
    `;
  }

  // One button per page context — "Buy Now" on the product page, "Add to
  // Cart" on the cart page — each with its own fully independent settings
  // (text, icon, colors, radius, shadow, animation, border, transparency,
  // page-background). Both trigger the exact same Cash on Delivery
  // order-form flow (openModal); only their look, label and which page they
  // appear on differ.
  function renderBuyButton(targetRoot) {
    const rootEl = targetRoot || root;
    const prefix = PAGE_TYPE === 'cart' ? 'atc' : 'buy';
    const fallbackText = prefix === 'atc' ? 'Add to Cart' : 'Buy Now';
    const fallbackBg = prefix === 'atc' ? '#111111' : '#dd5e33';

    // Root wrapper stays fully transparent — the button carries its own
    // independent background/border, so there's no single color left to
    // paint a shared backdrop with (see wrapWithBackdrop below).
    rootEl.style.setProperty('background', 'transparent', 'important');
    rootEl.style.setProperty('display', 'block', 'important');
    rootEl.style.setProperty('line-height', 'normal', 'important');

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.id = prefix === 'atc' ? 'cod-atc-btn' : 'cod-buy-btn';
    btn.innerHTML = btnHtml(prefix, fallbackText);
    // The normal (non-sticky) Buy Now button on the product page can have
    // its own left/right side margin (buy_btn_margin_h) — the 'atc'
    // button is left untouched here since it already has its own, more
    // elaborate width/align/margin system via wrapWithBackdrop below.
    if (prefix === 'buy') {
      const buyMarginH = Number(SETTINGS.buy_btn_margin_h || 0);
      const hs = hardShadow(prefix);
      btn.style.cssText = btnStyleCss(prefix, fallbackBg, '#ffffff') +
        ` width:calc(100% - ${buyMarginH * 2 + (hs ? hs.x : 0)}px) !important; margin:0 ${buyMarginH}px ${hs ? hs.y : 0}px ${buyMarginH}px !important;`;
    } else {
      const hs = hardShadow(prefix);
      btn.style.cssText = btnStyleCss(prefix, fallbackBg, '#ffffff') + (hs ? ` margin:0 ${hs.x}px ${hs.y}px 0 !important;` : ' margin:0 !important;');
    }
    btn.addEventListener('click', openModal);

    rootEl.appendChild(wrapWithBackdrop(btn, prefix));

    applyBtnAnimation(btn, SETTINGS[prefix + '_btn_animation'], SETTINGS[prefix + '_btn_bg'] || fallbackBg);

    // Mobile sticky scroll bar — product page only. Once the inline Buy Now
    // button scrolls out of view above the viewport, a second always-
    // visible copy slides in fixed to the bottom of the screen, so the COD
    // button stays reachable while browsing a long product page on a phone.
    // An earlier version of this had its own separate corner-rounding
    // wrapper (a workaround for an iOS Safari quirk) that kept diverging
    // from the other buttons and was a repeated source of bugs, so it was
    // removed. This rebuild deliberately reuses the exact same styling path
    // as every other button on the page (btnStyleCss/btnHtml/
    // applyBtnAnimation, the same width:100% treatment used by the cart's
    // own persistent bar) instead of inventing a third one.
    if (prefix === 'buy' && SETTINGS.buy_btn_sticky !== false && window.matchMedia('(max-width: 768px)').matches && !document.getElementById('cod-buy-bar-sticky')) {
      renderStickyProductBar(btn, false);
    }
  }

  // Sticky-only mode (app embed, no inline button anywhere on the page to
  // observe) — the floating bar has no inline button to wait for, so it
  // shows immediately on load instead of waiting for one to scroll out of
  // view, and on every screen size (not just mobile, since there is no
  // desktop inline button to fall back on either).
  function renderStickyOnlyProductBar() {
    if (SETTINGS.buy_btn_sticky === false) return;
    if (document.getElementById('cod-buy-bar-sticky')) return;
    renderStickyProductBar(null, true);
  }

  function renderStickyProductBar(inlineBtn, alwaysVisible) {
    const stickyBar = document.createElement('div');
    stickyBar.id = 'cod-buy-bar-sticky';
    // Background forced transparent — same reasoning as renderPersistentCartBar
    // above: btnWrapperBgColor('buy') is for the inline button's own
    // corner backdrop, not a solid bar behind the floating sticky copy.
    // will-change + isolation give this fixed, transform-animated bar its
    // own stable compositing layer up front — the same fix applied to the
    // animation classes above, for the same reason: without it, the
    // browser can briefly mis-clip the rounded button inside it right as
    // the slide-up transform starts, showing a thin stray line at the
    // bottom edge during the entrance animation.
    //
    // REAL ROOT CAUSE of the "curved red/green sliver poking up from the
    // bottom-right" bug: when this bar is in its hidden resting state
    // (translateY(100%) — pushed exactly one bar-height below the
    // viewport), the BUTTON inside it can still be running its own chosen
    // animation (bounce moves it translateY(-5px), scalepulse/tada scale
    // it up, wiggle rotates it, etc). That motion is relative to the
    // button's position WITHIN this bar, and this bar previously had no
    // `overflow`, so nothing stopped the animated button from visually
    // escaping past the bar's own top edge — which sits exactly at the
    // viewport's bottom edge while hidden. A few px of bounce/scale was
    // therefore enough for a rounded corner of the button to poke back
    // into view, even though the bar itself was correctly positioned
    // off-screen. Fix: `overflow:hidden` on the bar (so nothing the
    // button does can ever escape this box) plus a little extra
    // `padding-top` (so the animation still has visible room to move
    // in its normal, SHOWN state without clipping itself there).
    stickyBar.style.cssText = `
      position: fixed; left: 0; right: 0; bottom: 0; z-index: 2147483000;
      background: transparent;
      padding: 14px 0 env(safe-area-inset-bottom);
      overflow: hidden;
      transform: translateY(100%); transition: transform .2s ease;
      will-change: transform; isolation: isolate;
    `;
    const stickyBtn = document.createElement('button');
    stickyBtn.type = 'button';
    stickyBtn.innerHTML = btnHtml('buy', 'Buy Now');
    // Same full-rounding treatment as the cart's persistent bar — see the
    // comment there for why the old flat-bottom top-corners-only style was
    // removed. Side inset is merchant-adjustable via buy_btn_sticky_margin
    // (Dashboard: Buy Now button settings), default 4px either side.
    // BUG FIXED: was `SETTINGS.buy_btn_sticky_margin || 4` — 0 is falsy in
    // JS, so a merchant setting this Dashboard field to 0 (wanting a truly
    // edge-to-edge sticky button) silently got the 4px default back every
    // time, with no way to actually reach 0. `??` only falls back when the
    // value is missing (null/undefined), not when it's a legitimate 0.
    const stickyMargin = Number(SETTINGS.buy_btn_sticky_margin ?? 4);
    stickyBtn.style.cssText = btnStyleCss('buy', '#dd5e33', '#ffffff') +
      ` width:calc(100% - ${stickyMargin * 2}px) !important; margin:0 ${stickyMargin}px !important;`;
    stickyBtn.addEventListener('click', openModal);
    stickyBar.appendChild(stickyBtn);
    document.body.appendChild(stickyBar);
    applyBtnAnimation(stickyBtn, SETTINGS.buy_btn_animation, SETTINGS.buy_btn_bg || '#dd5e33');

    // Hidden (slid down) until the inline button scrolls above the viewport.
    //
    // FIX: at threshold:0 with no buffer, `boundingClientRect.top < 0`
    // flips to true the instant the inline button's top edge crosses the
    // viewport's top pixel — but IntersectionObserver callbacks are
    // batched per animation frame, not pixel-exact, so during fast/
    // momentum scrolling the reported rect can lag or jitter right at
    // that exact boundary. The visible symptom was the sticky bar
    // starting its slide-up ("peeking" from the bottom) a little before
    // the inline button had actually, fully scrolled past — i.e. while
    // it could still arguably be considered on-screen. A small negative
    // buffer means the button has to be unambiguously, meaningfully
    // above the viewport (not just 1px past a jittery boundary) before
    // the sticky bar is allowed to appear, which removes that premature
    // peek without adding any noticeable delay to the normal case.
    const PEEK_GUARD_PX = 16;
    if (alwaysVisible) {
      // No inline button exists on this page to track scroll position
      // against (sticky-only/app-embed mode) — this bar IS the button, so
      // it shows right away instead of waiting to be "scrolled past".
      stickyBar.style.transform = 'translateY(0)';
    } else if (inlineBtn && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // Show the bar whenever the inline button is NOT on screen: either
          // scrolled up past it, or not reached yet (below the fold) — so on
          // a long mobile product page the order button is always reachable.
          const r = entry.boundingClientRect;
          const scrolledPast = !entry.isIntersecting && r.top < -PEEK_GUARD_PX;
          const notReached = !entry.isIntersecting && r.top > 0;
          stickyBar.style.transform = (scrolledPast || notReached) ? 'translateY(0)' : 'translateY(100%)';
        });
      }, { threshold: 0, rootMargin: `-${PEEK_GUARD_PX}px 0px 0px 0px` });
      observer.observe(inlineBtn);
    }
  }

  // ---------- Modal ----------
  function buildModal() {
    overlayEl = document.createElement('div');
    overlayEl.id = 'cod-modal-overlay';
    // position:absolute (not fixed), pinned to the top of the document and
    // appended last in <body> — not its own fixed-viewport box with its own
    // overflow. This way there is no popup-level scrollbar at all: when the
    // form is taller than one screen, the *document itself* grows and the
    // browser's own native scrollbar scrolls it (the same thing that
    // happens on a native "Buy it now" page), so the submit button is
    // always reachable exactly where a normal page would put it — never
    // clipped inside a box with its own internal scroll area.
    // Max practical z-index — this popup must sit above ANY other
    // element on the page, including third-party apps' own sticky bars
    // (some of which deliberately use very high z-index values of their
    // own to always stay on top), not just this theme's elements.
    overlayEl.style.cssText = 'display:none; position:absolute; top:0; left:0; right:0; min-height:100vh; background:rgba(0,0,0,0.5); z-index:2147483646; padding:16px; box-sizing:border-box;';
    overlayEl.addEventListener('click', (e) => { if (e.target === overlayEl) closeModal(); });

    modalEl = document.createElement('div');
    modalEl.id = 'cod-modal-box';
    const headingFont = SETTINGS.heading_font && SETTINGS.heading_font !== 'inherit' ? SETTINGS.heading_font : 'inherit';
    const bodyFont = SETTINGS.body_font && SETTINGS.body_font !== 'inherit' ? SETTINGS.body_font : 'inherit';
    let formSt = {};
    try { formSt = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { formSt = {}; }
    formSt = formSt || {};
    const formRadius = (formSt.form_radius === undefined || formSt.form_radius === null || isNaN(Number(formSt.form_radius))) ? 14 : Math.max(0, Math.min(40, Number(formSt.form_radius)));
    modalEl.style.cssText = `
      background:${SETTINGS.form_bg || '#ffffff'}; border-radius:${formRadius}px; max-width:420px; width:100%;
      margin:24px auto; padding:20px; position:relative; font-family:${bodyFont}; box-sizing:border-box;
    `;

    modalEl.innerHTML = `
      <button type="button" id="cod-modal-close" style="position:absolute; top:4px; right:8px; width:28px; height:28px; padding:0; line-height:28px; text-align:center; background:none; border:none; font-size:22px; cursor:pointer; color:#888; z-index:3;">×</button>
      ${offerBannerHtml()}
      ${headingHtml(headingFont)}
      <div id="cod-prodcard">${PAGE_TYPE === 'cart' ? cartItemsHtml() : singleProductHtml()}</div>
      <form id="cod-order-form">
        <div id="cod-fields-wrap"></div>
        <div id="cod-amtbox" style="padding:10px 12px; border-radius:8px; font-size:12.5px; margin:12px 0;">
          <div style="display:flex; justify-content:space-between;"><span>Subtotal</span><span id="cod-subtotal">-</span></div>
          <div style="display:flex; justify-content:space-between;"><span>Delivery</span><span id="cod-delivery">-</span></div>
          <div style="display:flex; justify-content:space-between; font-weight:700;"><span>Total</span><span id="cod-total">-</span></div>
        </div>
        <button type="submit" id="cod-submit-btn"></button>
        <p id="cod-form-message" style="display:none; margin-top:10px; padding:10px; border-radius:8px; font-size:13.5px;"></p>
      </form>
    `;

    styleProdCard();
    styleAmtBox();
    renderFieldInputs(); showEmailHint(false);
    styleSubmitBtn();
    recomputeTotals();

    overlayEl.appendChild(modalEl);
    document.body.appendChild(overlayEl);

    modalEl.querySelector('#cod-modal-close').addEventListener('click', closeModal);
    const qtyMinusEl = modalEl.querySelector('#cod-qty-minus');
    const qtyPlusEl = modalEl.querySelector('#cod-qty-plus');
    if (qtyMinusEl) qtyMinusEl.addEventListener('click', () => changeQty(-1));
    if (qtyPlusEl) qtyPlusEl.addEventListener('click', () => changeQty(1));
    modalEl.querySelector('#cod-order-form').addEventListener('submit', handleSubmit);
  }

  // ---------- Button animations (Buy/Submit, chosen independently in Dashboard) ----------
  function injectAnimationStyles() {
    if (document.getElementById('cod-btn-anim-styles')) return;
    const style = document.createElement('style');
    style.id = 'cod-btn-anim-styles';
    style.textContent = `
      @keyframes codFreePop { 0%,100% { transform:scale(1); text-shadow:0 0 0 rgba(22,163,74,0); } 50% { transform:scale(1.18); text-shadow:0 0 10px rgba(22,163,74,0.55); } }
      @keyframes codBnShine { 0% { transform:translateX(-120%); } 60%,100% { transform:translateX(260%); } }
      @keyframes codBnPulse { 0%,100% { transform:scale(1); } 50% { transform:scale(1.03); } }
      @keyframes codBnFade { 0%,100% { opacity:1; } 50% { opacity:0.55; } }
      @keyframes codBnMarquee { 0% { transform:translateX(0); } 100% { transform:translateX(-100%); } }
      @media (prefers-reduced-motion: reduce) { .cod-note-field, .cod-note-field span { animation:none !important; } }
      @keyframes codAnimPulse { 0%,100% { box-shadow:0 0 0 0 var(--cod-glow, rgba(0,0,0,0.35)); } 50% { box-shadow:0 0 0 10px rgba(0,0,0,0); } }
      @keyframes codAnimBounce { 0%,50%,100% { transform:translateY(0); } 25% { transform:translateY(-5px); } }
      @keyframes codAnimScalePulse { 0%,100% { transform:scale(1); } 50% { transform:scale(1.035); } }
      @keyframes codAnimShimmerSweep { 0% { background-position:-150% 0; } 100% { background-position:250% 0; } }
      @keyframes codAnimWiggle { 0%,100% { transform:rotate(0deg); } 20% { transform:rotate(-4deg); } 40% { transform:rotate(4deg); } 60% { transform:rotate(-3deg); } 80% { transform:rotate(3deg); } }
      @keyframes codAnimTada { 0%,100% { transform:scale(1) rotate(0deg); } 10%,20% { transform:scale(0.92) rotate(-3deg); } 30%,50%,70%,90% { transform:scale(1.08) rotate(3deg); } 40%,60%,80% { transform:scale(1.08) rotate(-3deg); } }
      @keyframes codAnimHeartbeat { 0%,40%,60%,100% { transform:scale(1); } 20% { transform:scale(1.12); } 50% { transform:scale(1.07); } }
      @keyframes codAnimRainbowGlow { 0% { filter:hue-rotate(0deg); } 100% { filter:hue-rotate(360deg); } }
      /* The button's own box-shadow is always set inline with !important
         (so merchants' shadow-intensity setting reliably wins over the
         theme's own CSS) — and a CSS animation can never win against an
         !important declaration on that same property, on the same element.
         Animating box-shadow directly on .cod-anim-pulse therefore had no
         visible effect at all. Instead, the glow ring is drawn on a ::after
         overlay that carries no inline styles of its own, so nothing
         competes with it. */
      /* All three of these combine overflow:hidden (or an inset pseudo-
         element) with border-radius on an element that is itself animated
         (or, for the sticky bars, sits inside a parent that gets
         CSS-transform-slid in/out). Safari and Chrome have a known
         rendering bug where border-radius clipping briefly fails at the
         exact moment a GPU compositing layer is created/updated for an
         animated/transformed element — the clipped content (here, the
         shimmer's white sweep, or the pulse/rainbow glow ring) can leak
         out as a thin stray line at an edge or corner for a frame or two.
         Forcing each of these onto its own stable compositing layer up
         front (translateZ(0) + backface-visibility:hidden) is the
         standard fix: it makes the browser establish the layer (and its
         clip) once, ahead of time, instead of re-deriving it mid-animation. */
      .cod-anim-pulse { position:relative; transform:translateZ(0); -webkit-transform:translateZ(0); backface-visibility:hidden; -webkit-backface-visibility:hidden; }
      .cod-anim-pulse::after {
        content:''; position:absolute; inset:0; border-radius:inherit;
        animation: codAnimPulse 1.6s ease-in-out infinite;
        pointer-events:none;
      }
      .cod-anim-bounce { animation: codAnimBounce 1.3s ease-in-out infinite; }
      .cod-anim-scalepulse { animation: codAnimScalePulse 1.6s ease-in-out infinite; }
      .cod-anim-shimmer {
        position:relative; overflow:hidden;
        transform:translateZ(0); -webkit-transform:translateZ(0);
        backface-visibility:hidden; -webkit-backface-visibility:hidden;
        isolation:isolate;
      }
      .cod-anim-shimmer::after {
        content:''; position:absolute; inset:0;
        background:linear-gradient(120deg, transparent 35%, rgba(255,255,255,0.45) 50%, transparent 65%);
        background-size:200% 100%; background-position:-150% 0;
        animation: codAnimShimmerSweep 2.2s ease-in-out infinite;
        pointer-events:none;
      }
      .cod-anim-wiggle { animation: codAnimWiggle 1.8s ease-in-out infinite; }
      .cod-anim-tada { animation: codAnimTada 2.2s ease-in-out infinite; }
      .cod-anim-heartbeat { animation: codAnimHeartbeat 1.4s ease-in-out infinite; }
      /* Same z-index:-1-on-a-position:relative-parent trick used for the
         pulse glow ring above — this keeps the colorful ring confined to
         BEHIND the button's own background within its own local stacking
         context (position:relative creates that), instead of it either
         covering the button's text or escaping to sit behind the whole
         page. */
      .cod-anim-rainbow { position:relative; transform:translateZ(0); -webkit-transform:translateZ(0); backface-visibility:hidden; -webkit-backface-visibility:hidden; }
      .cod-anim-rainbow::after {
        content:''; position:absolute; inset:-4px; border-radius:inherit;
        background:conic-gradient(from 0deg, #ff4d4d, #ffb84d, #ffe14d, #4dff88, #4dc3ff, #9b4dff, #ff4d4d);
        filter:blur(5px);
        z-index:-1;
        animation: codAnimRainbowGlow 3s linear infinite;
        pointer-events:none;
      }
    `;
    document.head.appendChild(style);
  }

  // Applies the chosen animation (none/pulse/shimmer/bounce/scalepulse) to a
  // button element, independently of whatever other inline styles it has.
  function applyBtnAnimation(btn, animationName, bgColorForGlow) {
    injectAnimationStyles();
    btn.classList.remove('cod-anim-pulse', 'cod-anim-bounce', 'cod-anim-scalepulse', 'cod-anim-shimmer', 'cod-anim-wiggle', 'cod-anim-tada', 'cod-anim-heartbeat', 'cod-anim-rainbow');
    if (!animationName || animationName === 'none') return;
    btn.classList.add('cod-anim-' + animationName);
    if (animationName === 'pulse') {
      btn.style.setProperty('--cod-glow', hexToRgba(bgColorForGlow, 0.5));
    }
  }

  function hexToRgba(hex, alpha) {
    hex = (hex || '#dd5e33').replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
    const r = parseInt(hex.substring(0, 2), 16) || 0;
    const g = parseInt(hex.substring(2, 4), 16) || 0;
    const b = parseInt(hex.substring(4, 6), 16) || 0;
    return `rgba(${r},${g},${b},${alpha})`;
  }
function lightenHex(hex, amount) {
  hex = (hex || '#dd5e33').replace('#', '');
  if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
  const r = parseInt(hex.substring(0, 2), 16) || 0;
  const g = parseInt(hex.substring(2, 4), 16) || 0;
  const b = parseInt(hex.substring(4, 6), 16) || 0;
  const lr = Math.round(r + (255 - r) * amount);
  const lg = Math.round(g + (255 - g) * amount);
  const lb = Math.round(b + (255 - b) * amount);
  return `rgb(${lr},${lg},${lb})`;
}
  function styleProdCard() {
    const el = modalEl.querySelector('#cod-prodcard');
    el.style.background = SETTINGS.prod_card_bg || '#fafafa';
    el.style.color = SETTINGS.prod_card_text_color || '#1a1a1a';
    el.style.border = '1px solid ' + (SETTINGS.prod_card_border_color || '#e5e7eb');
    el.style.borderRadius = (SETTINGS.prod_card_radius ?? 12) + 'px';
    el.style.padding = '10px';
    el.style.marginBottom = '12px';
  }

  // ---------- Single-product view (product page) ----------
  // Product image size (px) in the popup's product summary — set from the
  // dashboard (Field Style -> Product summary card). Default 48.
  function prodImgSize() {
    let st = {};
    try { st = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { st = {}; }
    const n = Number(st && st.prod_img_size);
    return n >= 30 && n <= 140 ? Math.round(n) : 48;
  }

  function prodImgRadius() {
    let st = {};
    try { st = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { st = {}; }
    const n = Number(st && st.prod_img_radius);
    return st && st.prod_img_radius !== undefined && n >= 0 && n <= 60 ? Math.round(n) : 8;
  }

  function prodImgBorderCss() {
    let st = {};
    try { st = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { st = {}; }
    const w = Math.max(0, Math.min(8, Number(st && st.prod_img_border_width) || 0));
    if (!w) return '';
    const c = String((st && st.prod_img_border_color) || '#cccccc').replace(/[^#a-zA-Z0-9(),.% ]/g, '');
    return 'border:' + w + 'px solid ' + c + ';';
  }

  function singleProductHtml() {
    return `
      <div style="display:flex; align-items:center; gap:10px;">
        <div style="width:${prodImgSize()}px; height:${prodImgSize()}px; border-radius:${prodImgRadius()}px; background:#eee; ${prodImgBorderCss()} box-sizing:border-box; flex-shrink:0; overflow:hidden; display:flex; align-items:center; justify-content:center; font-size:8px; color:#999;">
          ${normalizeImageUrl(PRODUCT_IMAGE) ? `<img src="${normalizeImageUrl(PRODUCT_IMAGE)}" alt="" style="width:100%; height:100%; object-fit:cover; display:block;" onerror="this.style.display='none'; this.parentElement.textContent='No image';">` : 'No image'}
        </div>
        <div style="flex:1; min-width:0;">
          <div style="font-size:12.5px; font-weight:700; line-height:1.3; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;">${escapeHtml(PRODUCT_TITLE)}</div>
          ${(VARIANT_TITLE && VARIANT_TITLE !== 'Default Title') ? `<div id="cod-variant-label" style="font-size:11.5px; font-weight:600; margin-top:2px; opacity:.85;">${escapeHtml(VARIANT_TITLE)}</div>` : ''}
          <div id="cod-unit-price-label" style="font-size:11.5px; opacity:.7;">${fmt(UNIT_PRICE)}</div>
        </div>
        <div style="display:flex; align-items:center; border:1px solid #ddd; border-radius:8px; overflow:hidden; flex-shrink:0;">
          <button type="button" id="cod-qty-minus" style="width:26px; height:26px; border:none; background:#fff; font-size:14px; font-weight:700; cursor:pointer;">−</button>
          <span id="cod-qty-val" style="width:28px; text-align:center; font-size:12.5px; font-weight:700; display:inline-block;">1</span>
          <button type="button" id="cod-qty-plus" style="width:26px; height:26px; border:none; background:#fff; font-size:14px; font-weight:700; cursor:pointer;">+</button>
        </div>
      </div>
    `;
  }

  // ---------- Cart-items view (cart page) — one row per item, read-only.
  // Quantities are the cart's own (edited on the cart page itself, not
  // here) so there's no stepper, just the live list + a running total.
  function cartItemDisplayTitle(it) {
    const base = it.product_title || it.title || '';
    const variant = it.variant_title || '';
    return (variant && variant !== 'Default Title') ? base + ' - ' + variant : base;
  }

  function cartItemsHtml() {
    const items = (CART_DATA && CART_DATA.items) || [];
    const rows = items.map((it) => `
      <div style="display:flex; align-items:center; gap:10px; padding:6px 0; border-bottom:1px solid rgba(0,0,0,0.06);">
        <div style="width:${Math.round(prodImgSize() * 0.83)}px; height:${Math.round(prodImgSize() * 0.83)}px; border-radius:${prodImgRadius()}px; background:#eee; ${prodImgBorderCss()} box-sizing:border-box; flex-shrink:0; overflow:hidden; display:flex; align-items:center; justify-content:center; font-size:7px; color:#999;">
          ${it.image ? `<img src="${normalizeImageUrl(it.image)}" alt="" style="width:100%; height:100%; object-fit:cover; display:block;" onerror="this.style.display='none';">` : ''}
        </div>
        <div style="flex:1; min-width:0;">
          <div style="font-size:12px; font-weight:600; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${escapeHtml(cartItemDisplayTitle(it))}</div>
          <div style="font-size:11px; opacity:.7;">Qty: ${it.quantity}</div>
        </div>
        <div style="font-size:12px; font-weight:700; flex-shrink:0;">${fmt((it.final_line_price ?? it.line_price ?? 0) / 100)}</div>
      </div>
    `).join('');
    return `<div>${rows}</div>`;
  }

  function styleAmtBox() {
    const el = modalEl.querySelector('#cod-amtbox');
    el.style.background = SETTINGS.amt_box_bg || '#f7f7f7';
    el.style.color = SETTINGS.amt_box_text_color || '#1a1a1a';
    el.style.border = '1px solid ' + (SETTINGS.amt_box_border_color || '#f7f7f7');
    el.style.borderRadius = (SETTINGS.amt_box_radius ?? 8) + 'px';
  }

  // Shared animated-banner markup (used by "Highlighted banner" fields and the
  // popup's top offer banner). animate undefined/true = ON, false = OFF.
  function bannerMarkup(f, attrs, extraStyle) {
    const on = f.animate !== false;
    const style = f.anim_style || 'shimmer';
    const speedMul = f.anim_speed === 'slow' ? 1.8 : f.anim_speed === 'fast' ? 0.55 : 1;
    const fs = Math.max(9, Math.min(28, Number(f.font_size) || 12.5));
    const align = ['left', 'center', 'right'].indexOf(f.align) >= 0 ? f.align : 'left';
    const weight = f.bold === false ? 400 : 600;
    const base = (extraStyle || '') + ' padding:8px 12px; border-radius:' + (f.radius === undefined || f.radius === null || isNaN(Number(f.radius)) ? 8 : Math.max(0, Math.min(40, Number(f.radius)))) + 'px; position:relative; overflow:hidden; font-size:' + fs + 'px; font-weight:' + weight + '; text-align:' + align + '; background:' + f.bg + '; color:' + f.text_color + ';';
    const txt = escapeHtml(f.text);
    if (!on) return `<div ${attrs} style="${base}">${txt}</div>`;
    if (style === 'marquee') {
      return `<div ${attrs} style="${base} white-space:nowrap;"><span style="display:inline-block; padding-left:100%; animation:codBnMarquee ${(12 * speedMul).toFixed(1)}s linear infinite;">${txt}</span></div>`;
    }
    if (style === 'pulse') {
      return `<div ${attrs} style="${base} animation:codBnPulse ${(1.6 * speedMul).toFixed(1)}s ease-in-out infinite;">${txt}</div>`;
    }
    if (style === 'fade') {
      return `<div ${attrs} style="${base} animation:codBnFade ${(1.8 * speedMul).toFixed(1)}s ease-in-out infinite;">${txt}</div>`;
    }
    return `<div ${attrs} style="${base}"><span style="position:absolute; top:0; bottom:0; left:0; width:45%; background:linear-gradient(100deg,transparent,rgba(255,255,255,0.55),transparent); animation:codBnShine ${(2.6 * speedMul).toFixed(1)}s ease-in-out infinite; pointer-events:none;"></span><span style="position:relative;">${txt}</span></div>`;
  }

  function showEmailHint(show) {
    if (!modalEl) return;
    const emailInput = modalEl.querySelector('.cod-field-input[data-field-id="email"]');
    if (!emailInput) return;
    let eh = modalEl.querySelector('.cod-email-hint');
    if (!eh) {
      eh = document.createElement('div');
      eh.className = 'cod-email-hint';
      eh.style.cssText = 'font-size:11.5px; color:#dc2626; margin-top:4px; display:none;';
      emailInput.parentNode.appendChild(eh);
      emailInput.addEventListener('input', function () {
        eh.style.display = 'none';
        emailInput.style.border = `${SETTINGS.field_border_width ?? 1}px solid ${SETTINGS.field_border_color || '#cccccc'}`;
      });
      emailInput.addEventListener('blur', function () {
        const v = stripEmoji(emailInput.value).trim();
        if (v && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) showEmailHint(true);
      });
    }
    if (show) {
      emailInput.style.border = `${SETTINGS.field_border_width ?? 1}px solid #dc2626`;
      eh.textContent = emailErrMsg();
      eh.style.display = 'block';
    }
  }
  function emailErrMsg() {
    let st = {};
    try { st = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { st = {}; }
    return st.email_error || 'Please enter a valid email (e.g. name@gmail.com) or leave this field empty.';
  }
  function headingHtml(headingFont) {
    let st = {};
    try { st = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { st = {}; }
    st = st || {};
    const size = Math.max(10, Math.min(40, Number(st.heading_size) || 16));
    const align = ['left', 'center', 'right'].indexOf(st.heading_align) >= 0 ? st.heading_align : 'left';
    const weight = st.heading_bold === false ? 400 : 700;
    const color = st.heading_color ? 'color:' + st.heading_color + ';' : '';
    const anims = { pulse: 'codBnPulse 1.6s ease-in-out infinite', fade: 'codBnFade 1.8s ease-in-out infinite', bounce: 'codAnimBounce 1.6s ease-in-out infinite' };
    const anim = anims[st.heading_anim] || '';
    if (anim) injectAnimationStyles();
    return `<h3 style="margin:0 0 12px; font-family:${headingFont}; font-size:${size}px; font-weight:${weight}; text-align:${align}; ${color} padding-right:20px;${anim ? ' animation:' + anim + ';' : ''}">${escapeHtml(SETTINGS.form_heading || 'Cash on Delivery — Order Now')}</h3>`;
  }

  function offerBannerHtml() {
    if (!SETTINGS.offer_text) return '';
    injectAnimationStyles();
    let st = {};
    try { st = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { st = {}; }
    st = st || {};
    const accent = SETTINGS.accent_color || '#dd5e33';
    return bannerMarkup(Object.assign({}, st, {
      text: SETTINGS.offer_text,
      bg: st.bg || hexToRgba(accent, 0.12),
      text_color: st.text_color || accent,
    }), 'id="cod-offer-banner"', 'margin:22px 0 12px 0;');
  }

  function renderFieldInputs() {
    injectAnimationStyles();
    const wrap = modalEl.querySelector('#cod-fields-wrap');
    wrap.innerHTML = FIELDS.map(f => {
      if (f.hidden && (f.type === 'note' || f.type === 'shipping_banner')) return '';
      if (f.type === 'note') {
        // Not a real input — a merchant-authored HTML block (no label, no
        // value collected on submit), positioned in the field order like
        // any other field so it can be dragged anywhere in Fields & Order.
        return `<div class="cod-note-field" style="margin-bottom:10px; font-size:12.5px; line-height:1.5; color:${SETTINGS.field_text_color || '#1a1a1a'};">${f.html || ''}</div>`;
      }
      if (f.type === 'shipping_banner') {
        if (!f.text) return '';
        return bannerMarkup(Object.assign({}, f, { bg: f.bg || '#fff7e6', text_color: f.text_color || '#92610a' }), 'class="cod-note-field"', 'margin-bottom:10px;');
      }
      const req = f.required ? ' required' : '';
      const reqMark = f.required ? ' <span style="color:#dc2626;">*</span>' : '';
      let inputHtml;
      if (f.type === 'dropdown') {
        const opts = (f.options && f.options.length ? f.options : ['Select...']).map(o => `<option>${escapeHtml(o)}</option>`).join('');
        inputHtml = `<select class="cod-field-input" data-field-id="${f.id}"${req}>${opts}</select>`;
      } else if (f.type === 'searchable') {
        // Type-ahead: a plain text field is the value itself (so it always
        // submits cleanly), with a live-filtered suggestion list underneath
        // that always ends in a customizable fallback line — clicking it
        // just closes the list and lets the customer keep typing freely,
        // so there's never a dead end if their city isn't in the list.
        inputHtml = `<input type="text" class="cod-field-input" data-field-id="${f.id}" autocomplete="off" placeholder="${escapeHtml(f.placeholder || '')}"${req}>` +
          `<div class="cod-suggest-box" data-suggest-for="${f.id}" style="display:none;"></div>`;
      } else if (f.id === 'phone') {
        inputHtml = `<input type="tel" inputmode="numeric" class="cod-field-input" data-field-id="${f.id}" placeholder="${escapeHtml(f.placeholder || '03xxxxxxxxx')}"${req}>` +
          `<div class="cod-phone-hint" style="display:none; font-size:11.5px; color:#dc2626; margin-top:4px;">${escapeHtml(SETTINGS.phone_hint_message || 'Please add your complete phone number which starts from 0')}</div>`;
      } else {
        inputHtml = `<input type="text" class="cod-field-input" data-field-id="${f.id}" placeholder="${escapeHtml(f.placeholder || '')}"${req}>`;
      }
      const wrapStyle = f.type === 'searchable' ? 'margin-bottom:10px; position:relative;' : 'margin-bottom:10px;';
      return `<div style="${wrapStyle}"><label style="display:block; font-size:12.5px; font-weight:600; margin-bottom:5px;">${escapeHtml(f.label)}${reqMark}</label>${inputHtml}</div>`;
    }).join('');

    {
      let phSt = {};
      try { phSt = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { phSt = {}; }
      const phColor = phSt && /^#[0-9a-fA-F]{3,8}$/.test(phSt.ph_color || '') ? phSt.ph_color : '';
      let phEl = document.getElementById('cod-ph-style');
      if (phColor) {
        if (!phEl) { phEl = document.createElement('style'); phEl.id = 'cod-ph-style'; document.head.appendChild(phEl); }
        phEl.textContent = '#cod-modal-box .cod-field-input::placeholder { color: ' + phColor + ' !important; opacity: 1 !important; }';
      } else if (phEl) phEl.remove();
    }
    wrap.querySelectorAll('.cod-field-input').forEach(el => {
      el.style.cssText = `
        width:100%; box-sizing:border-box; padding:9px 11px; font-size:13px;
        background:${SETTINGS.field_bg || '#ffffff'}; color:${SETTINGS.field_text_color || '#1a1a1a'};
        border:${SETTINGS.field_border_width ?? 1}px solid ${SETTINGS.field_border_color || '#cccccc'};
        border-radius:${SETTINGS.field_radius ?? 6}px;
        box-shadow:${Number(SETTINGS.field_shadow || 0) > 0 ? '0 ' + SETTINGS.field_shadow + 'px ' + (SETTINGS.field_shadow * 2) + 'px rgba(0,0,0,0.12)' : 'none'};
      `;
    });

    // Note fields may include images from the RTE's "attach image" button —
    // keep those from overflowing the popup.
    wrap.querySelectorAll('.cod-note-field img').forEach(img => {
      img.style.maxWidth = '100%';
      img.style.height = 'auto';
      img.style.borderRadius = '8px';
      img.style.display = 'block';
      img.style.margin = '6px 0';
    });

    attachSearchableBehavior();
    attachPhoneValidation();
    attachNoEmoji();
  }

  // Shopify rejects emojis in name/address fields, so don't let customers
  // type or paste them in the first place.
  const EMOJI_RE = /[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}\u200d\ufe0f\u20e3]/gu;
  function stripEmoji(s) { return String(s == null ? '' : s).replace(EMOJI_RE, ''); }
  function attachNoEmoji() {
    modalEl.querySelectorAll('.cod-field-input[data-field-id]').forEach(el => {
      el.addEventListener('input', () => {
        const clean = stripEmoji(el.value);
        if (clean !== el.value) {
          const pos = el.selectionStart;
          el.value = clean;
          try { el.setSelectionRange(Math.max(0, pos - 2), Math.max(0, pos - 2)); } catch (e) {}
        }
      });
    });
  }

  // ---------- Live phone validation ----------
  // As the customer types: digits-only, capped at 11 characters. The field
  // turns red and a hint message shows the moment they've typed something
  // but it isn't yet a full 11-digit number (starting 0) -- it clears back
  // to normal the instant they reach 11 digits, so it never nags an empty
  // or already-correct field.
  function attachPhoneValidation() {
    const input = modalEl.querySelector('.cod-field-input[data-field-id="phone"]');
    const hint = modalEl.querySelector('.cod-phone-hint');
    if (!input) return;

    const normalBorder = `${SETTINGS.field_border_width ?? 1}px solid ${SETTINGS.field_border_color || '#cccccc'}`;
    const errorBorder = `${SETTINGS.field_border_width ?? 1}px solid #dc2626`;

    function validate() {
      let v = input.value.replace(/\D/g, '');
      // Auto-fix common ways customers type a Pakistani mobile number:
      // "3001234567" (zero missing) and "+92 300 1234567" / "923001234567".
      if (v.startsWith('92') && v.length > 2) v = '0' + v.slice(2);
      else if (v.startsWith('3')) v = '0' + v;
      input.value = v.slice(0, 11);
      const isPartial = input.value.length > 0 && !/^03[0-9]{9}$/.test(input.value);
      input.style.border = isPartial ? errorBorder : normalBorder;
      if (hint) hint.style.display = isPartial ? 'block' : 'none';
    }

    input.addEventListener('input', validate);
    input.addEventListener('blur', validate);
  }



  function attachSearchableBehavior() {
    FIELDS.forEach(f => {
      if (f.type !== 'searchable') return;
      const input = modalEl.querySelector(`.cod-field-input[data-field-id="${f.id}"]`);
      const suggestBox = modalEl.querySelector(`.cod-suggest-box[data-suggest-for="${f.id}"]`);
      if (!input || !suggestBox) return;

      suggestBox.style.cssText = `
        position:absolute; left:0; right:0; top:100%; margin-top:4px;
        background:${SETTINGS.field_bg || '#ffffff'};
        border:${SETTINGS.field_border_width ?? 1}px solid ${SETTINGS.field_border_color || '#cccccc'};
        border-radius:${SETTINGS.field_radius ?? 6}px; max-height:220px; overflow-y:auto;
        z-index:100000; box-shadow:0 6px 18px rgba(0,0,0,0.15); display:none;
      `;

      const options = f.options || [];
      const fallbackText = f.otherLabel || ('✍️ Type your own ' + f.label);
      const accent = SETTINGS.accent_color || '#dd5e33';

      function renderSuggestions(query) {
        suggestBox.innerHTML = '';
        const q = query.trim().toLowerCase();
        const matches = q ? options.filter(o => o.toLowerCase().startsWith(q)) : options;
        const shown = matches.slice(0, 8);

        shown.forEach(opt => {
          const item = document.createElement('div');
          item.textContent = opt;
          item.style.cssText = 'padding:9px 11px; cursor:pointer; font-size:13px;';
          item.addEventListener('mousedown', (e) => {
            e.preventDefault();
            input.value = opt;
            suggestBox.style.display = 'none';
          });
          item.addEventListener('mouseenter', () => { item.style.background = '#f2f2f2'; });
          item.addEventListener('mouseleave', () => { item.style.background = ''; });
          suggestBox.appendChild(item);
        });

        if (!shown.length) {
          const none = document.createElement('div');
          none.textContent = 'No match found';
          none.style.cssText = 'padding:9px 11px; font-size:12.5px; color:#999;';
          suggestBox.appendChild(none);
        }

        const fallbackItem = document.createElement('div');
        fallbackItem.textContent = fallbackText;
        fallbackItem.style.cssText = `padding:9px 11px; cursor:pointer; font-size:13px; color:${accent}; border-top:1px solid #eee; font-weight:600;`;
        fallbackItem.addEventListener('mousedown', (e) => {
          e.preventDefault();
          suggestBox.style.display = 'none';
          input.focus();
        });
        fallbackItem.addEventListener('mouseenter', () => { fallbackItem.style.background = '#f9f9f9'; });
        fallbackItem.addEventListener('mouseleave', () => { fallbackItem.style.background = ''; });
        suggestBox.appendChild(fallbackItem);

        suggestBox.style.display = 'block';
      }

      input.addEventListener('focus', () => renderSuggestions(input.value));
      input.addEventListener('input', () => renderSuggestions(input.value));
      input.addEventListener('blur', () => {
        // Small delay so a mousedown on a suggestion registers before the list disappears.
        setTimeout(() => { suggestBox.style.display = 'none'; }, 150);
      });
    });
  }

  function styleSubmitBtn() {
    const btn = modalEl.querySelector('#cod-submit-btn');
    const shadow = Number(SETTINGS.submit_btn_shadow || 0);
    const buttonFontFamily = SETTINGS.button_font && SETTINGS.button_font !== 'inherit' ? SETTINGS.button_font : 'inherit';
    btn.style.cssText = `
      width:100% !important; padding:12px !important; border:none !important; cursor:pointer; ${btnTextStyle('submit')} font-family:${buttonFontFamily}; box-sizing:border-box !important;
      background:${SETTINGS.submit_btn_bg || '#111111'} !important; background-image:none !important; color:${SETTINGS.submit_btn_text_color || '#ffffff'};
      border-radius:${SETTINGS.submit_btn_radius ?? 8}px !important;
      box-shadow:${shadow > 0 ? '0 ' + shadow + 'px ' + (shadow * 3) + 'px rgba(0,0,0,0.18)' : 'none'};
      -webkit-appearance:none !important; -moz-appearance:none !important; appearance:none !important; outline:none;
      background-clip:padding-box !important; -webkit-background-clip:padding-box !important;
    `;
    applyBtnAnimation(btn, SETTINGS.submit_btn_animation, SETTINGS.submit_btn_bg || '#111111');
    updateSubmitBtnText();
  }

  function updateSubmitBtnText() {
    const btn = modalEl.querySelector('#cod-submit-btn');
    const total = computeTotal();
    const template = SETTINGS.submit_btn_text || 'Place Your Order — Your Amount is {amount}';
    const text = template.replace('{amount}', fmt(total));
    btn.innerHTML = iconHtml('submit') + escapeHtml(text);
  }

  // ---------- Quantity / totals ----------
  function changeQty(delta) {
    qty = Math.max(1, qty + delta);
    modalEl.querySelector('#cod-qty-val').textContent = qty;
    recomputeTotals();
  }

  function cartSubtotal() {
    const items = (CART_DATA && CART_DATA.items) || [];
    return items.reduce((sum, it) => sum + ((it.final_line_price ?? it.line_price ?? 0) / 100), 0);
  }

  function computeTotal() {
    const subtotal = PAGE_TYPE === 'cart' ? cartSubtotal() : UNIT_PRICE * qty;
    const delivery = Number(SETTINGS.cod_fee || 0);
    return subtotal + delivery;
  }

  function recomputeTotals() {
    const subtotal = PAGE_TYPE === 'cart' ? cartSubtotal() : UNIT_PRICE * qty;
    const delivery = Number(SETTINGS.cod_fee || 0);
    const total = subtotal + delivery;
    modalEl.querySelector('#cod-subtotal').textContent = fmt(subtotal);
    const delEl = modalEl.querySelector('#cod-delivery');
    let os = {};
    try { os = typeof SETTINGS.offer_style === 'string' ? JSON.parse(SETTINGS.offer_style || '{}') : (SETTINGS.offer_style || {}); } catch (e) { os = {}; }
    os = os || {};
    const freeOn = os.free_anim !== false;
    if (delivery === 0) {
      const label = (os.free_text || 'Free').slice(0, 30) + (os.free_emoji === false ? '' : ' 🚚');
      if (!freeOn) {
        delEl.textContent = label;
      } else {
        injectAnimationStyles();
        const anims = { pop: 'codFreePop 1.4s ease-in-out infinite', blink: 'codBnFade 1.1s ease-in-out infinite', bounce: 'codAnimBounce 1.4s ease-in-out infinite', wiggle: 'codAnimWiggle 1.6s ease-in-out infinite', heartbeat: 'codAnimHeartbeat 1.3s ease-in-out infinite', shine: 'codAnimShimmerSweep 2s linear infinite' };
        const sp = document.createElement('span');
        const fc = os.free_color || '#16a34a';
        sp.style.cssText = 'display:inline-block; font-weight:800; color:' + fc + '; animation:' + (anims[os.free_style] || anims.pop) + ';';
        if (os.free_style === 'shine') {
          sp.style.cssText += ' background:linear-gradient(100deg,' + fc + ' 30%,#ffffff 50%,' + fc + ' 70%); background-size:250% 100%; -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent;';
        }
        sp.textContent = label;
        delEl.textContent = '';
        delEl.appendChild(sp);
      }
    } else {
      delEl.textContent = fmt(delivery);
    }
    modalEl.querySelector('#cod-total').textContent = fmt(total);
    updateSubmitBtnText();
  }

  // ---------- Open / close ----------
  async function openModal() {
    // Called with an event argument = normal button click -> use the page's
    // own mode. Called with none = from the cart drawer (CODOrderCart).
    if (arguments.length && PAGE_TYPE !== PAGE_TYPE_BASE) {
      PAGE_TYPE = PAGE_TYPE_BASE;
      const pc = modalEl && modalEl.querySelector('#cod-prodcard');
      if (pc && PAGE_TYPE !== 'cart') { pc.innerHTML = singleProductHtml(); recomputeTotals(); }
    }
    if (PAGE_TYPE === 'cart') {
      // Re-fetch so a cart changed via AJAX (added/removed items) after page
      // load is reflected accurately, then re-render the item list + totals.
      try {
        const res = await fetch('/cart.js', { cache: 'no-store' });
        CART_DATA = await res.json();
      } catch (e) { /* fall back to the last-known CART_DATA */ }

      if (!CART_DATA.items || CART_DATA.items.length === 0) return;

      const limitMax = Number(SETTINGS.cart_limit_max ?? 4);
      if (SETTINGS.cart_limit_enabled !== false && CART_DATA.items.length > limitMax) {
        showAlertOverlay(
          SETTINGS.cart_limit_message ||
            'You are ordering more different products than allowed in one order. For bulk or mixed orders, please contact us on WhatsApp.',
          'error'
        );
        return;
      }

      const prodcard = modalEl.querySelector('#cod-prodcard');
      if (prodcard) prodcard.innerHTML = cartItemsHtml();
      recomputeTotals();
    }

    // Remember where the page was scrolled to, so we can put it back on
    // close, then open the overlay as part of the normal document flow
    // (no body-scroll lock) — the page itself scrolls it, same as the
    // native "Buy it now" flow, with no popup-level scrollbar at all.
    codScrollRestoreY = window.scrollY;
    overlayEl.style.display = 'block';
    // Cover at least as much height as the full underlying page, not just
    // one screen — otherwise an extra scroll past a short modal's own
    // height would reveal un-covered page content peeking out below the
    // backdrop on a long product page.
    overlayEl.style.minHeight = Math.max(document.documentElement.scrollHeight, window.innerHeight) + 'px';
    window.scrollTo(0, 0);
    trackFormOpen();
    firePixelEvent('InitiateCheckout', Object.assign(
      { value: computeTotal(), currency: CURRENCY_CODE },
      buildPixelContents()
    ));
  }

  function closeModal() {
    overlayEl.style.display = 'none';
    window.scrollTo(0, codScrollRestoreY || 0);
  }

  function trackFormOpen() {
    fetch(HOSTS[hostIdx] + '/api/track/form-open', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shop_domain: SHOP, product_id: PRODUCT_ID }),
    }).catch(() => {});
  }

  // ---------- Submit ----------
  async function handleSubmit(e) {
    e.preventDefault();
    const submitBtn = modalEl.querySelector('#cod-submit-btn');
    const messageEl = modalEl.querySelector('#cod-form-message');
    messageEl.style.display = 'none';

    const values = {};
    modalEl.querySelectorAll('.cod-field-input').forEach(el => {
      values[el.dataset.fieldId] = stripEmoji(el.value).trim();
    });

    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const phoneBad = !/^03[0-9]{9}$/.test(values.phone || '');
    const emailBad = !!values.email && !EMAIL_RE.test(values.email);
    if (phoneBad) {
      const phoneInput = modalEl.querySelector('.cod-field-input[data-field-id="phone"]');
      const hint = modalEl.querySelector('.cod-phone-hint');
      if (phoneInput) {
        phoneInput.style.border = `${SETTINGS.field_border_width ?? 1}px solid #dc2626`;
      }
      if (hint) hint.style.display = 'block';
    }
    // Email is optional, but if typed it must be valid. Shown inline (same
    // style as the phone hint) at the same time as any phone error.
    if (emailBad) showEmailHint(true);
    if (phoneBad || emailBad) {
      const first = modalEl.querySelector('.cod-field-input[data-field-id="' + (phoneBad ? 'phone' : 'email') + '"]');
      if (first) first.focus();
      return;
    }

    // Default fields map straight to backend columns; anything extra (custom
    // fields) gets folded into the address as extra notes since the orders
    // table only has fixed columns.
    let extraNotes = [];
    FIELDS.forEach(f => {
      if (!['name', 'phone', 'city', 'address', 'email'].includes(f.id) && values[f.id]) {
        extraNotes.push(f.label + ': ' + values[f.id]);
      }
    });
    const addressFull = extraNotes.length
      ? (values.address || '') + ' | ' + extraNotes.join(' | ')
      : (values.address || '');

    const subtotal = PAGE_TYPE === 'cart' ? cartSubtotal() : UNIT_PRICE * qty;
    const delivery = Number(SETTINGS.cod_fee || 0);
    const total = subtotal + delivery;

    const purchaseEventId = newEventId();
    const payload = {
      event_id: purchaseEventId,
      fbp: getCookie('_fbp') || undefined,
      fbc: getFbc() || undefined,
      event_source_url: window.location.href,
      utm: getUtm(),
      shop_domain: SHOP,
      customer_name: values.name || '',
      phone: values.phone || '',
      email: values.email || undefined,
      city: values.city || '',
      address: addressFull,
      amount: subtotal,
      delivery_charge: delivery,
      discount_percent: 0,
      final_amount: total,
    };

    if (PAGE_TYPE === 'cart') {
      payload.cart_items = ((CART_DATA && CART_DATA.items) || []).map((it) => ({
        product_id: it.product_id,
        variant_id: it.variant_id,
        title: cartItemDisplayTitle(it),
        quantity: it.quantity,
        unit_price: (it.price || 0) / 100,
      }));
    } else {
      payload.quantity = qty;
      payload.product_id = PRODUCT_ID;
      payload.variant_id = VARIANT_ID;
      payload.product_title = getDisplayTitle();
    }

    submitBtn.disabled = true;
    const originalHtml = submitBtn.innerHTML;
    submitBtn.textContent = 'Placing order...';

    try {
      const res = await postOrderFetch({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (data.ok && data.status !== 'blocked') {
        firePixelEvent('Purchase', Object.assign(
          { value: total, currency: CURRENCY_CODE },
          buildPixelContents()
        ), purchaseEventId);

        // Straight to Shopify's own order status page (name, address,
        // phone, order details already shown there) -- no inline success
        // message first, just go. A short pause (only when a browser pixel
        // is configured) gives fbq/ttq time to actually send the Purchase
        // request before the page unloads; navigating in the same tick can
        // cancel it. The server-side event still covers us either way.
        if (data.redirect_url) {
          const hasBrowserPixel = PIXELS.some((p) => p.type === 'facebook_pixel' || p.type === 'tiktok_pixel');
          if (hasBrowserPixel) {
            setTimeout(() => { window.location.href = data.redirect_url; }, 300);
          } else {
            window.location.href = data.redirect_url;
          }
          return;
        }

        messageEl.innerHTML = 'Your order has been received! We will call you shortly to confirm.';
        messageEl.style.background = '#e6f7ea';
        messageEl.style.color = '#1a7a34';
        messageEl.style.display = 'block';
        modalEl.querySelector('#cod-order-form').reset();
        qty = 1;
        const qtyValReset = modalEl.querySelector('#cod-qty-val');
        if (qtyValReset) qtyValReset.textContent = 1;
        recomputeTotals();
        setTimeout(closeModal, 2500);
      } else if (data.ok && data.status === 'blocked') {
        showAlertOverlay(data.message || 'This order could not be accepted.', 'error');
      } else if (data.error === 'invalid_email') {
        showAlertOverlay(emailErrMsg(), 'error');
      } else {
        showAlertOverlay('Something went wrong. Please check your details and try again.', 'error');
      }
    } catch (err) {
      showAlertOverlay('Could not place order. Please check your internet connection.', 'error');
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalHtml;
    }
  }

  // ---------- Alert overlay (for blocked/error messages — handles rich content like images safely) ----------
  function showAlertOverlay(html, kind) {
    const bg = kind === 'error' ? '#fdeaea' : '#e6f7ea';
    const color = kind === 'error' ? '#b32424' : '#1a7a34';

    const alertOverlay = document.createElement('div');
    // One above the order-form overlay (2147483646) — alerts fire while
    // that popup is open and must paint on top of it.
    //
    // FIX: this used to center the card with `align-items:center` on a
    // fixed, non-scrolling overlay and rely on the card's own
    // `max-height:80vh; overflow-y:auto` to make long content (e.g. a
    // blocked-order message with a logo/image) scrollable. On mobile,
    // `vh` units are measured against the LAYOUT viewport, which is
    // taller than the actually-visible VISUAL viewport whenever the
    // browser's address bar/toolbar is showing — so a card computed at
    // "80vh" could be taller than what's actually on screen, and because
    // the outer overlay itself had no overflow, there was no way to
    // scroll down to reach the "OK" button at the bottom of the card. It
    // looked exactly like a hidden/cut-off OK button.
    //
    // Fix: make the OVERLAY itself scrollable (`overflow-y:auto`) and let
    // the card size to its natural content height, anchored with
    // `align-items:flex-start` + `margin:auto 0` — a standard flexbox
    // trick that still visually centers the card when it fits the screen,
    // but falls back to normal top-anchored scrolling (so the OK button
    // is always reachable) when it doesn't.
    alertOverlay.style.cssText = 'position:fixed; inset:0; background:rgba(0,0,0,0.55); z-index:2147483647; display:flex; align-items:flex-start; justify-content:center; padding:20px; overflow-y:auto; -webkit-overflow-scrolling:touch;';

    const card = document.createElement('div');
    card.style.cssText = 'background:#fff; border-radius:14px; max-width:380px; width:100%; padding:20px; position:relative; box-sizing:border-box; margin:auto 0;';
    card.innerHTML = `
      <button type="button" id="cod-alert-close" style="position:absolute; top:8px; right:10px; background:none; border:none; font-size:20px; cursor:pointer; color:#888; line-height:1;">×</button>
      <div id="cod-alert-body" style="padding:12px 14px; border-radius:10px; background:${bg}; color:${color}; font-size:13.5px; line-height:1.6; margin-top:14px;">${html}</div>
      <button type="button" id="cod-alert-ok" style="margin-top:14px; width:100%; padding:11px; border:none; border-radius:8px; background:#111; color:#fff; font-weight:700; cursor:pointer; font-size:13.5px;">OK</button>
    `;
    card.querySelectorAll('img').forEach(img => {
      const userW = img.style.width;
      const alignEl = img.closest('[style*="text-align"]');
      const al = alignEl ? alignEl.style.textAlign : '';
      img.style.maxWidth = '100%';
      img.style.maxHeight = '220px';
      img.style.width = userW || 'auto';
      img.style.height = 'auto';
      img.style.objectFit = 'contain';
      img.style.borderRadius = '8px';
      img.style.display = 'block';
      img.style.margin = al === 'center' ? '8px auto' : (al === 'right' ? '8px 0 8px auto' : '8px 0');
    });

    alertOverlay.appendChild(card);
    document.body.appendChild(alertOverlay);

    const close = () => alertOverlay.remove();
    card.querySelector('#cod-alert-close').addEventListener('click', close);
    card.querySelector('#cod-alert-ok').addEventListener('click', close);
    alertOverlay.addEventListener('click', (e) => { if (e.target === alertOverlay) close(); });
  }

  // ---------- Pixels ----------
  // Only client-side pixel types (Facebook Pixel, TikTok Pixel) fire from here.
  // Conversions API / Events API types need a server-side call with the access
  // token and are not fired from the browser.
  function preloadPixelBaseScripts() {
    PIXELS.forEach(p => {
      if (p.type === 'facebook_pixel') loadFacebookPixel(p.pixel_id);
      if (p.type === 'tiktok_pixel') loadTikTokPixel(p.pixel_id);
    });
  }

  function loadFacebookPixel(pixelId) {
    // Don't init a pixel twice: the Shopify Facebook & Instagram channel (or the
    // theme) may already have initialised this same ID, and a second init makes
    // Meta log "Duplicate Pixel ID" and can double-count PageView.
    window.__codFbInit = window.__codFbInit || {};
    if (window.__codFbInit[pixelId]) return;
    if (window.fbq && typeof window.fbq.getState === 'function') {
      try {
        const st = window.fbq.getState();
        if (st && st.pixels && st.pixels.some((x) => String(x.id) === String(pixelId))) { window.__codFbInit[pixelId] = true; return; }
      } catch (e) { /* fall through to init */ }
    }
    window.__codFbInit[pixelId] = true;
    if (window.fbq) { window.fbq('init', pixelId); return; }
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', pixelId);
  }

  function loadTikTokPixel(pixelId) {
    if (window.ttq && window.ttq._loaded) { return; }
    (function (w, d, t) {
      w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || [];
      ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
      ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) { var e = ttq._i[t] || []; for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; };
      ttq.load = function (e, n) {
        var i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = i; ttq._t = ttq._t || {}; ttq._t[e] = +new Date; ttq._o = ttq._o || {}; ttq._o[e] = n || {};
        var o = d.createElement('script'); o.type = 'text/javascript'; o.async = !0; o.src = i + '?sdkid=' + e + '&lib=' + t;
        var a = d.getElementsByTagName('script')[0]; a.parentNode.insertBefore(o, a);
      };
      ttq.load(pixelId);
      ttq.page();
      ttq._loaded = true;
    })(window, document, 'ttq');
  }

  // Builds the content_id / content_ids / contents fields both Facebook
  // Pixel and TikTok Pixel expect on standard e-commerce events. Without
  // these, TikTok logs "Missing content_id parameter" and Facebook's Events
  // Manager similarly flags the event as missing recommended parameters.
  // Covers both single-product (product page) and multi-item (cart page)
  // checkouts, and includes both FB's `id`/`content_ids` naming and
  // TikTok's `content_id` naming on each item so one shared `data` object
  // works for both pixels.
  function buildPixelContents() {
    if (PAGE_TYPE === 'cart' && CART_DATA && CART_DATA.items && CART_DATA.items.length) {
      const items = CART_DATA.items;
      const ids = items.map((it) => String(it.variant_id || it.product_id || ''));
      return {
        content_type: 'product',
        content_id: ids[0] || '',
        content_ids: ids,
        contents: items.map((it) => ({
          id: String(it.variant_id || it.product_id || ''),
          content_id: String(it.variant_id || it.product_id || ''),
          quantity: it.quantity || 1,
          item_price: (it.price || 0) / 100,
          price: (it.price || 0) / 100,
        })),
      };
    }
    const vid = String(VARIANT_ID || PRODUCT_ID || '');
    return {
      content_type: 'product',
      content_id: vid,
      content_ids: [vid],
      contents: [{
        id: vid,
        content_id: vid,
        quantity: qty || 1,
        item_price: UNIT_PRICE,
        price: UNIT_PRICE,
      }],
    };
  }

  // ---------- Ad attribution (UTM) ----------
  // Ad links land with ?utm_source=...&utm_campaign=... in the URL, but the
  // customer usually browses a page or two before ordering, so the URL on
  // the order page no longer has them. Remember the latest set for this
  // browser tab (sessionStorage = last-touch, gone when the tab closes, so
  // an old ad click can't be credited to a much later organic order) and
  // send it with the order, where it lands in the Shopify order's
  // "Additional details" under the same names Releasit used.
  // Note: only pages that load this script can capture them — an ad that
  // lands on a page without the COD button (e.g. home) isn't seen here.
  // UTMs plus the ad-click ids (fbclid = Meta, ttclid = TikTok); all captured/stored together.
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid'];

  function captureUtm() {
    try {
      const params = new URLSearchParams(window.location.search);
      const found = {};
      UTM_KEYS.forEach((k) => {
        const v = params.get(k);
        if (v) found[k] = v.slice(0, 200);
      });
      if (Object.keys(found).length) {
        // Meta browser ids saved with the click: the real _fbc cookie if the pixel set it,
        // otherwise Meta's documented fallback fb.1.<ms>.<fbclid>. _fbp is stored only if it
        // exists (it cannot be made up).
        const ck = getCookie('_fbc') || (found.fbclid ? 'fb.1.' + Date.now() + '.' + found.fbclid : '');
        if (ck) found.fbc = ck.slice(0, 200);
        const bp = getCookie('_fbp');
        if (bp) found.fbp = bp.slice(0, 200);
        window.sessionStorage.setItem('cod_utm', JSON.stringify(found));
        try { window.localStorage.setItem('cod_utm_ls', JSON.stringify({ t: Date.now(), utm: found })); } catch (e2) { /* ignore */ }
      }
    } catch (e) { /* storage blocked (private mode etc.) — just no UTM */ }
  }

  function readSavedUtm() {
    try {
      const saved = JSON.parse(window.sessionStorage.getItem('cod_utm') || '{}');
      if (saved && typeof saved === 'object' && Object.keys(saved).length) return saved;
    } catch (e) { /* fall through to the longer-lived copy */ }
    // Longer-lived copy (30 days) written by the header snippet / captureUtm,
    // so UTMs survive a new tab or a visit across several pages.
    try {
      const ls = JSON.parse(window.localStorage.getItem('cod_utm_ls') || 'null');
      if (ls && ls.utm && typeof ls.utm === 'object' && Date.now() - Number(ls.t || 0) < 30 * 24 * 3600 * 1000) return ls.utm;
    } catch (e) { /* ignore */ }
    return {};
  }

  // Saved UTMs + click ids, refreshed at order time with the live Meta cookies
  // (the pixel usually sets _fbc/_fbp after the first page load).
  function getUtm() {
    const out = Object.assign({}, readSavedUtm());
    try {
      const fbc = getCookie('_fbc');
      if (fbc) out.fbc = fbc.slice(0, 200);
      const fbp = getCookie('_fbp');
      if (fbp) out.fbp = fbp.slice(0, 200);
    } catch (e) { /* ignore */ }
    return out;
  }

  function getCookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  // Facebook click id: the _fbc cookie if the pixel already set it, otherwise
  // rebuilt from ?fbclid= in the landing URL (same format Meta documents:
  // fb.1.<timestamp ms>.<fbclid>) so ad-click attribution isn't lost when the
  // cookie isn't there yet.
  function getFbc() {
    const c = getCookie('_fbc');
    if (c) return c;
    try {
      const id = new URLSearchParams(window.location.search).get('fbclid');
      if (id) return 'fb.1.' + Date.now() + '.' + id;
    } catch (e) { /* ignore */ }
    return '';
  }

  // Shared by the browser Purchase event and the server (Conversions API)
  // Purchase for the SAME order — Meta de-duplicates the pair only when
  // event_name AND event_id match, so one id is generated per submit and
  // sent both ways. Without it every order was counted twice whenever both
  // a Facebook Pixel and a Conversions API entry exist for the shop.
  function newEventId() {
    return 'cod_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  function firePixelEvent(eventName, data, eventId) {
    PIXELS.forEach(p => {
      try {
        if (p.type === 'facebook_pixel' && window.fbq) {
          // trackSingle targets only THIS pixel id. Plain fbq('track') sends
          // to every pixel initialised on the page, so with 2+ Facebook
          // pixels each event went to every pixel multiple times.
          const fbEvent = eventName === 'Purchase' ? 'Purchase' : 'InitiateCheckout';
          if (eventId) window.fbq('trackSingle', p.pixel_id, fbEvent, data, { eventID: eventId });
          else window.fbq('trackSingle', p.pixel_id, fbEvent, data);
        }
        if (p.type === 'tiktok_pixel' && window.ttq) {
          const ttEvent = eventName === 'Purchase' ? 'CompletePayment' : 'InitiateCheckout';
          window.ttq.track(ttEvent, data);
        }
      } catch (e) { /* never let a pixel error block checkout */ }
    });
  }

  // ---------- Stay in sync with the theme's own variant/size picker ----------
  // Product templates dispatch `cod:variant-change` (detail: the matched
  // Shopify variant object) whenever the customer picks a different size/
  // color. We update our own state and, if the popup is already built,
  // refresh what's showing so it never lags behind what the customer
  // actually selected.
  document.addEventListener('cod:variant-change', function (e) {
    const v = e.detail;
    if (!v || PAGE_TYPE === 'cart') return;
    VARIANT_ID = v.id;
    VARIANT_TITLE = v.title || '';
    UNIT_PRICE = Number(v.price || 0) / 100;
    if (v.featured_image && v.featured_image.src) PRODUCT_IMAGE = v.featured_image.src;

    if (modalEl) {
      const prodcard = modalEl.querySelector('#cod-prodcard');
      if (prodcard) prodcard.innerHTML = singleProductHtml();
      recomputeTotals();
    }
  });

  captureUtm();
  init();
})();
